function offsetRight() {
	var element = jQuery('.offset-right-inner');
	if(element.length) {
		var padding = element.css( "padding-right" ).replace("px", "");
		var offset = jQuery(window).width() - (element.offset().left + element.outerWidth());
		var right = parseInt(offset) + parseInt(padding);
		element.css('margin-right', -right);
	}
	
}

function offsetLeft() {
	var element = jQuery('.offset-left-inner');
	if(element.length) {
		var padding = element.css( "padding-left" ).replace("px", "");
		var offset = element.offset().left;
		var left = parseInt(offset) + parseInt(padding);
		element.css('margin-left', -left);
	}
	
}

jQuery(function($) {
	if(jQuery(window).width() > 767) {
		offsetRight();
		offsetLeft();
	}
  
});
jQuery(window).resize(function(){
  if(jQuery(window).width() > 767) {
	  offsetRight();
	  offsetLeft();
  }
});